import React from 'react';
import { t } from '@store/I18nStore'

export function EyeIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

type PasswordToggleProps = {
  visible: boolean;
  onToggle: () => void;
};

export function PasswordToggle({ visible, onToggle }: PasswordToggleProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={t('auth.password.show')}
      className={`absolute right-3 top-1/2 -translate-y-1/2 transition ${visible ? 'text-brand2' : 'text-slate-500 hover:text-slate-300'}`}
    >
      <EyeIcon />
    </button>
  );
}
